export default __webpack_public_path__ + "static/media/ic_admind_b.77edcb0c.svg";